import type { DocumentUploadedAtTableCellFragment } from "../client/generated";
import { DocumentDateTableCell } from "./DocumentDateTableCell";

type Props = {
  fragment: DocumentUploadedAtTableCellFragment;
};

export function DocumentUploadedAtTableCell({ fragment }: Props) {
  return <DocumentDateTableCell date={fragment.uploadedAt} />;
}
